const enums = {
  GENERAL: { text: 'general', value: 2 },
  NOT_BIND: { text: 'not connected', value: 4 },
  SHOPIFY: { text: 'Shopify', value: 1 },
  WOOCOMMERCE: { text: 'Woo', value: 3 },
  ETSY: { text: 'Etsy', value: 5 }
}
export default enums
